import * as yup from "yup";

export const CertifRevSchema = yup
    .object({
        rc_rut: yup
            .string()
            .required('El RUT es requerido.')
            .test('len', 'El RUT no es válido o no pertenece a una persona natural.', (val) => {
                if (val === undefined) {
                    return true;
                }
                return new RegExp(/^\d{8,9}[0-9Kk]$/).test(val.replaceAll('-', '').replaceAll('.', ''));
            }),
        rc_email: yup
            .string()
            .required('El correo es requerido.')
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'El correo no es válido.'),
    })
    .required();

